import { colors } from 'colors';
import styled from 'styled-components';

export const CallRecordingWrapper = styled.div`
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  background-color: #1a2330;
  color: white;
  min-height: 100vh;
  margin-top: 100px;
  
  .recording-header {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    
    .meeting-icon {
      width: 40px;
      height: 40px;
      font-size: 24px;
      margin-right: 16px;
      background-color: #2a3442;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .meeting-info {
      h2 {
        margin: 0 0 8px;
        color: #fff;
        font-weight: 400;
        font-size: 28px;
      }
      
      .meeting-meta {
        color: #9ea7b8;
        font-size: 14px;
        
        .meeting-date {
          margin-right: 16px;
        }
      }
    }
  }
  
  .loading-message {
    text-align: center;
    padding: 30px;
    color: #9ea7b8;
  }
  
  .error {
    color: #ef5350;
    padding: 10px;
    background-color: rgba(239, 83, 80, 0.1);
    border-radius: 4px;
    margin: 10px 0;
  }
  
  .recording-container {
    display: flex;
    gap: 24px;
    
    .main-content {
      flex: 1;
      
      .video-container {
        position: relative;
        margin-bottom: 24px;
        background-color: #000;
        border-radius: 8px;
        overflow: hidden;
        aspect-ratio: 16 / 9;
        
        video {
          display: block;
          width: 100%;
          height: 100%;
          cursor: pointer;
          object-fit: contain;
        }
        
        .video-error {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background-color: rgba(0, 0, 0, 0.8);
          color: #ef5350;
          padding: 12px 16px;
          border-radius: 4px;
          text-align: center;
          max-width: 80%;
          font-size: 14px;
          z-index: 2;
        }
        
        .video-controls {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
          padding: 16px;
          display: flex;
          align-items: center;
          z-index: 1;
          
          .play-button {
            background-color: transparent;
            color: white;
            border: none;
            width: 30px;
            height: 30px;
            font-size: 18px;
            cursor: pointer;
            margin-right: 10px;
          }
          
          .time-display {
            color: white;
            margin-right: 10px;
            font-size: 13px;
            min-width: 100px;
          }
          
          .progress-bar {
            flex-grow: 1;
            height: 4px;
            -webkit-appearance: none;
            appearance: none;
            background: rgba(255, 255, 255, 0.3);
            border-radius: 2px;
            margin: 0 10px;
            
            &::-webkit-slider-thumb {
              -webkit-appearance: none;
              appearance: none;
              width: 12px;
              height: 12px;
              background: white;
              border-radius: 50%;
              cursor: pointer;
            }
          }
          
          .fullscreen-button {
            background-color: transparent;
            color: white;
            border: none;
            width: 30px;
            height: 30px;
            font-size: 16px;
            cursor: pointer;
          }
        }
      }
      
      .transcript-container {
        background-color: white;
        border-radius: 8px;
        overflow: hidden;
        
        .transcript-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 16px;
          background-color: white;
          border-bottom: 1px solid #eee;
          
          h3 {
            margin: 0;
            font-weight: 500;
            color: #333;
            font-size: 18px;
          }
          
          .search-form {
            display: flex;
            width: 50%;
            
            input {
              flex: 1;
              padding: 8px 12px;
              border: 1px solid #ddd;
              border-radius: 4px 0 0 4px;
              font-size: 14px;
              
              &:focus {
                outline: none;
                border-color: #1976d2;
              }
            }
            
            button {
              padding: 8px 16px;
              background-color: #1976d2;
              color: white;
              border: none;
              border-radius: 0 4px 4px 0;
              cursor: pointer;
              font-size: 14px;
              
              &:hover {
                background-color: #1565c0;
              }
            }
          }
        }
        
        .transcript-content {
          max-height: 400px;
          overflow-y: auto;
          background-color: white;
          color: #333;
          
          .transcript-line {
            display: flex;
            padding: 12px 16px;
            cursor: pointer;
            border-bottom: 1px solid #f5f5f5;
            
            &:hover {
              background-color: #f9f9f9;
            }
            
            &.active-line {
              background-color: #e3f2fd;
            }
            
            .transcript-line-left {
              margin-right: 12px;
              
              .avatar {
                width: 32px;
                height: 32px;
                border-radius: 50%;
                background-color: #e1f5fe;
                color: #0288d1;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 500;
              }
            }
            
            .transcript-line-right {
              flex: 1;
              
              .transcript-line-header {
                display: flex;
                justify-content: space-between;
                margin-bottom: 4px;
                
                .speaker-name {
                  font-weight: 500;
                  color: #333;
                }
                
                .timestamp {
                  color: #666;
                  font-size: 13px;
                }
              }
              
              .transcript-line-content {
                color: #444;
                line-height: 1.4;
              }
            }
          }
          
          .highlight-search {
            background-color: #fff9c4;
            padding: 0 2px;
            border-radius: 2px;
          }
          
          .raw-transcript {
            padding: 10px 16px;
            
            .raw-line {
              margin-bottom: 8px;
              padding-bottom: 8px;
              border-bottom: 1px solid #eee;
              font-family: monospace;
              font-size: 13px;
              white-space: pre-wrap;
              
              &:last-child {
                border-bottom: none;
                margin-bottom: 0;
                padding-bottom: 0;
              }
            }
          }
        }
      }
    }
    
    .attendees-container {
      width: 280px;
      h3 {
        margin: 0 0 16px;
        font-weight: 500;
        color: white;
        padding-bottom: 12px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      }
      
      .attendees-list {
        .attendee {
          display: flex;
          align-items: center;
          margin-bottom: 16px;
          
          .attendee-avatar {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            background-color: #5c6bc0;
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 500;
            margin-right: 12px;
          }
          
          .attendee-info {
            .attendee-name {
              font-weight: 500;
              color: white;
              margin-bottom: 2px;
            }
            
            .attendee-email {
              font-size: 13px;
              color: #9ea7b8;
            }
          }
        }
      }
    }
  }
`;
